let subscriptionData = null;
export const setSubscriptionData = (e) => {
  subscriptionData = e;
};

export const getSubscriptionData = () => {
  return subscriptionData;
};
